
export { DOMAIN_PARTS } from "/home/runner/work/apollo/apollo/packages/core/utils/validations/src/regex.ts"